export const FORMATO_RETRO_COMERCIAL = 2

export const PREGUNTAS_GENERALES = [
  { key: 'p1', texto: '¿Mantiene un tono de voz adecuado y profesional?' },
  { key: 'p2', texto: '¿Su tiempo de respuesta es oportuno?' },
  { key: 'p4', texto: '¿Es ágil en la atención de sus contactos?' },
  { key: 'p5', texto: '¿Mantiene contactos pendientes o en espera?' },
  { key: 'p6', texto: '¿Se comunica de manera formal y cordial con los prospectos?' },
  { key: 'p7', texto: '¿Mantiene organizada su bandeja de entrada?' },
]

export const PREGUNTAS_SEGUIMIENTO = [
  { key: 'valor1', texto: '¿Identifica las necesidades del prospecto?' },
  { key: 'valor2', texto: '¿El tiempo de respuesta es adecuado?' },
  { key: 'valor3', texto: '¿Personaliza sus mensajes y audios?' },
  { key: 'valor4', texto: '¿Presenta una propuesta de valor?' },
  { key: 'valor5', texto: '¿Maneja correctamente las objeciones?' },
  { key: 'valor6', texto: '¿Realiza un segundo seguimiento cuando corresponde?' },
  { key: 'valor7', texto: '¿La conversación avanza hacia una inscripción?' },
  { key: 'valor8', texto: '¿Propone un siguiente paso concreto para continuar con el proceso?' },
]

export function esFormatoComercial (item) {
  return Number(item && item.formato) === FORMATO_RETRO_COMERCIAL
}
